import { render, staticRenderFns } from "./ClearDB.vue?vue&type=template&id=4f35f8ba&"
import script from "./ClearDB.vue?vue&type=script&lang=js&"
export * from "./ClearDB.vue?vue&type=script&lang=js&"
import style0 from "./ClearDB.vue?vue&type=style&index=0&id=4f35f8ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports